module.exports = __webpack_public_path__ + "static/media/apple.f614fae8.svg";